export default __webpack_public_path__ + "images/f0efd0767ec3f77057270d84f78b1f41-3_4K_1920x544.jpg";